import { render, staticRenderFns } from "./LandingPageDE.vue?vue&type=template&id=12faea10&scoped=true"
import script from "./LandingPageDE.vue?vue&type=script&lang=js"
export * from "./LandingPageDE.vue?vue&type=script&lang=js"
import style0 from "../../assets/landing/styles.css?vue&type=style&index=0&id=12faea10&prod&scoped=true&lang=css&external"
import style1 from "./LandingPageDE.vue?vue&type=style&index=1&id=12faea10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12faea10",
  null
  
)

export default component.exports